import { AppStatus } from '@/redux'
import { waitFor } from '@codeleap/utils'
import { getFirebase } from '../../firebaseApp'
import { useProfile, useUpdateProfile } from './useProfile'
import { warnEmailInUse } from './utils'
import { ERRORS, isEmailAvailable, Profile } from './views'

export function useEdit() {
  const profile = useProfile()
  const updateProfile = useUpdateProfile()

  const editProfile = async (data: Partial<Profile>) => {
    AppStatus.set('loading')
    try {
      const emailAddressChanged = !!data.email?.trim() && data?.email?.trim() !== profile.data.email.trim()

      if (emailAddressChanged) {
        const emailAvailable = await isEmailAvailable(data.email)

        if (!emailAvailable) {
          warnEmailInUse()
          throw ERRORS.emailInUse
        }
        try {
          const firebase = await getFirebase()

          await firebase.auth().currentUser.updateEmail(data.email)
        } catch (e) {
          if (e.code === 'auth/requires-recent-login') {
            throw ERRORS.reautenticationRequired
          }
        }
      }
      const result = await updateProfile.mutateAsync(data)

      await profile.refetch()

      await waitFor(500)

      logger.log('Profile edited successfully', result, 'Auth')

      AppStatus.set('done')
    } catch (e) {
      logger.error('Failed to edit profile', e, 'Auth')
      AppStatus.set('idle')
      throw e
    }
  }

  return { editProfile }
}
